import { GiftCardsCategoriesNavList, GiftCardsCategoriesNavListItem } from './components';

export const GiftCardsCategoriesNav = {
  List: GiftCardsCategoriesNavList,
  ListItem: GiftCardsCategoriesNavListItem,
};
